import {TTSVoiceType} from "../../Server/DB/engineConfigs/@EngineConfig/@EC_Visualization.js";
import {NarrateTextOptions, NarrateTextOptionsInit} from "./TTS.js";

export function GetStandardFilePathForTTSOptions(options: NarrateTextOptionsInit) {
	const opt = new NarrateTextOptions(options);
	opt.Finalize();
	return `Alarms/LF/BakedTTS/volume(${opt._finalVolume})_speed(${opt._finalSpeed})_text(${opt.text}).wav`;
}

// probably rename this to GetStandardFilePathForTTSOptions_ElevenLabs, and rework to use GetStandardFilePathForTTSOptions for non-11-based
export function GetStandardFilePathForTTSOptions_ForVisualization(options: {text: string, ttsVoiceType: TTSVoiceType, elevenLabsVoiceId?: string}) {
	const {text, ttsVoiceType, elevenLabsVoiceId} = options;
	if (ttsVoiceType == "elevenLabs" && elevenLabsVoiceId) {
		return `Alarms/LF/BakedTTS/elevenLabs_voice(${elevenLabsVoiceId})_text(${text}).mp3`;
	}
	// For AndroidTTS, use standard path (volume=1, speed=1)
	return `Alarms/LF/BakedTTS/volume(1)_speed(1)_text(${text}).wav`;
}

export function GetFilePathForBakedSpatialAudio(poolName: string, durationInSecs: number, volume: number) {
	return `Alarms/LF/BakedSpatialAudio/pool(${poolName})_duration(${durationInSecs})_volume(${volume.RoundTo_Str(.01)}).wav`;
}